import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  deleting: boolean
  onDeleteNote: () => void
  onToggleModal: (isOpen: boolean) => void
}

const DeleteModal = ({ onToggleModal, onDeleteNote, deleting }: Props) => {
  return (
    <Modal
      illustration="delete"
      onClose={() => onToggleModal(false)}
      title={i18n.t('bookkeepers.incidence.note.remove_note.heading')}
      description={i18n.t('bookkeepers.incidence.note.remove_note.information')}
      footer={
        <>
          <Button type="secondary" onClick={() => onToggleModal(false)}>
            {i18n.t('bookkeepers.incidence.note.remove_note.button.cancel')}
          </Button>
          <Button type="primary" disabled={deleting} onClick={onDeleteNote}>
            {i18n.t('bookkeepers.incidence.note.remove_note.button.remove')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteModal
